/*
 * @Author: lzy
 * @Date: 2019-11-13 11:19:08
 * @LastEditTime: 2021-05-19 15:54:26
 * @LastEditors: cc
 * @Description: 企鹅号
 * @FilePath: \xjmediacloud\app\editingCenter\qiehao\qiehao.js
 */
angular
    .module('editCenterQiehaoModule', [
        'qiehaoRouterModule',
        'editQiehaoLeftModule',
        'editQiehaoPendingModule',
        'editQiehaoToBeCompiledModule',
        'editQiehaoSignedModule',
        'qiehaoServiceModule',
        'editQiehaoDraftBoxModule',
        'editQiehaoToBeCompiledVideoModule',
        'editQiehaoToBeCompiledNewsModule',
        'editQiehaoToBeCompiledAtlasModule',
    ])
    .controller('editCenterQiehaoCtrl', [function () { }])
    .value('qieConst', {
        listenStroageKey: 'Qiehao', // 监听缓存的名称
        idName: 'KUAIBAOARTICLEID', // 主要使用的ID名称
        trial: {
            // 送审参数
            serviceid: 'mlf_kuaibaoper',
            methodname: 'trialArticle',
        },
        sign: {
            // 签发参数
            serviceid: 'mlf_kuaibaoper',
            methodname: 'publishArticle',
        },
        waste: {
            // 废稿参数
            serviceid: 'mlf_kuaibaoper',
            methodname: 'abolishArticles',
        },
        export: {
            // 导出参数
            serviceid: 'mlf_kuaibaoper',
        },
        outsource: {
            // 外发参数
            serviceid: 'mlf_mailoutgoingOper',
            methodname: 'webDaiBianSendEmail',
        },
        graph: {
            // 图示参数
            serviceid: 'mlf_kuaibaoarticle',
            methodname: 'queryAllImgLogo',
        },
        draftListDB: {
            // 发稿单待编参数
            serviceid: 'mlf_appfgd',
            methodname: 'qieHaoDaiBianbatchUpdateFgdUsers',
        },
        draftListDS: {
            // 发稿单待审参数
            serviceid: 'mlf_appfgd',
            methodname: 'qieHaoDaiShenbatchUpdateFgdUsers',
        },
        draftListQuery: {
            // 发稿单查询参数
            serviceid: 'mlf_appfgd',
            methodName: 'queryFgdByQiehaoArticleId',
        },
        rejection: {
            // 撤稿参数
            serviceid: 'mlf_kuaibaoper',
            methodname: 'reTrialArticle',
        },
        cancelPublishArticle: {
            // 取消签发参数
            serviceid: 'mlf_kuaibaoper',
            methodname: 'cancelPublishArticle',
        }
    });
